import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const DoubleArrow = ({
  size,
  type,
  theme,
  className,
  dataTestId = "double-arrow-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.952 10.261a.666.666 0 1 0-.942.942l2.926 2.927c.26.26.682.26.942 0l2.927-2.927a.666.666 0 1 0-.943-.942l-1.789 1.79V5.01a.666.666 0 0 0-1.332 0v7.04l-1.79-1.789ZM14.048 6.025a.666.666 0 1 0 .942-.942l-2.926-2.927a.666.666 0 0 0-.942 0L8.195 5.083a.666.666 0 1 0 .942.942l1.79-1.79v7.04a.666.666 0 1 0 1.332 0v-7.04l1.789 1.79Z"
    />
  </SVGIcon>
);
